export default __webpack_public_path__ + "static/media/register10.a33b9fc8.jpg";